import React, { useState } from "react";
import { Box, Tab, Tabs, Typography, Paper } from "@mui/material";
import ProviderAvailableSchedule from "./ProviderAvailableSchedule";
import ProviderScheduleCreate from "./ProviderScheduleCreate";

const PersonalSchedule = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", textAlign: "center", color: "#028391" }}>
        Personal Schedule
      </Typography>

      
        <Tabs
          value={activeTab}
          onChange={(event, newValue) => setActiveTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="Availability" />
          <Tab label="Create Schedule" />
        </Tabs>

        <Box sx={{ padding: 2 }}>
          {activeTab === 0 && <ProviderAvailableSchedule />}
          {activeTab === 1 && <ProviderScheduleCreate />}
        </Box>
      
    </Box>
  );
};

export default PersonalSchedule;
